export class PreciseTimer {
    timers: any;
    constructor() {
        this.timers = new Map();
    }

    setTimeout(callback: () => void, delay: number) {
        const start = performance.now();
        const timerId = Symbol('timerId');

        const loop = (timestamp: number) => {
            const elapsed = timestamp - start;
            if (elapsed >= delay) {
                callback();
                this.timers.delete(timerId); // Remove timer after execution
            } else {
                if (this.timers.has(timerId)) {
                    this.timers.set(timerId, requestAnimationFrame(loop));
                }
            }
        };

        this.timers.set(timerId, requestAnimationFrame(loop));
        return timerId;
    }

    clearTimeout(timerId: any) {
        if (this.timers.has(timerId)) {
            cancelAnimationFrame(this.timers.get(timerId));
            this.timers.delete(timerId);
        }
    }
}
